var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isInitialized)?_c('FullScreenLoading',{attrs:{"opacity":0.8,"loading":true}}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }